import React, { Component } from "react";
import styled from "styled-components";
import { Icon as MaterialIcon, MenuItem } from "@material-ui/core";
import { ActionPermissionsObject, PermissionActionType, WorkspaceResourceType } from "common/interfaces";
import { Icon } from "js/Components/Icon";
import WorkspaceController from "js/controllers/WorkspaceController";
import AppController from "js/core/AppController";
import { ds } from "js/core/models/dataService";
import { sortTagsByPopularity } from "js/core/utilities/utilities";
import PresentationEditorController from "js/editor/PresentationEditor/PresentationEditorController";
import { UserMenu } from "js/editor/components/UserMenu";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { Gap10, Gap15, Gap20, Gap30 } from "js/react/components/Gap";
import { themeColors } from "js/react/sharedStyles";
import { ShareDialog } from "js/react/views/PresentationSettings/dialogs/ShareDialog";
import { TeamResourceTypes } from "js/react/views/TeamResources/TeamResources";
import { CreatePresentationDialogPaneType } from "js/editor/CreatePresentation/CreatePresentationDialogTypes";
import CreateTeamTemplateDialog from "js/react/views/TeamResources/dialogs/CreateTeamTemplateDialog";
import PresentationLibraryController from "js/controllers/PresentationLibraryController";

import { MenuPopup } from "../../../Components/Popup";
import { getStaticUrl } from "js/config";
import GuestWorkspaceDialog from "js/react/components/Dialogs/GuestWorkspaceDialog";
import { PresentationFilters } from "common/constants";
import { t } from "js/i18n";

const NavMenuContainer = styled.div`
    //width: 55px;
    height: 100%;
    //padding-left: 15px;
    background: #111;
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-right: solid 1px #444;
    cursor: pointer;

    &&&& {
        .MuiIcon-root, .bai-icon {
            color: ${themeColors.ui_blue} !important;
            font-weight: 800 !important;
        }
    }
`;

const MenuBarContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #222;
    width: 100%;
    height: 55px;
    padding: 0px;
    color: white;
    flex-shrink: 0;
    gap: 0px;

    &&& {
        .bai-icon, .MuiIcon-root {
            font-size: 20px;
            color: white !important;
        }
    }

    .bai-popup {
        label {
            text-transform: uppercase;
            font-size: 12px;
            white-space: nowrap;
        }

        .bai-icon {
            color: white !important;
            font-size: 20px;
            margin-right: 2px;
        }
    }

    .bai-button {
        .bai-icon {
            color: white !important;
        }

        & > span {
            color: #f1f1f1;
            font-weight: 600;
            font-size: 12px;
        }

    }

    &.light {
        background: white;
        color: #222;
        border-bottom: solid 1px #ccc;

        ${NavMenuContainer} {
            background: #eee;
            border-right: solid 1px #ccc;
        }

        .bai-icon {
            color: #333 !important;
        }

        .bai-button {
            span {
                color: #333;
            }
        }

        #presentation-name {
            color: #444;
        }
    }
`;

const UserMenuContainer = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MenuBarHighlighterWrapper = styled.div`               
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px 10px;
    position: relative;

    .tooltip {
        opacity: 0;
        position: absolute;
        bottom: -3px;
        left: 50%;
        width: 200px;
        transform: translateX(-50%);
        font-size: 8px;
        color: white;
        text-align: center;
        transition: 0.2s;
        background: none;
        pointer-events: none;
        text-transform: uppercase;
    }

    &:hover {
        .tooltip {
            opacity: 1;
        }
    }
`;

class MenuBarHighlighter extends Component {
    render() {
        const { toolTip } = this.props;
        return (
            <MenuBarHighlighterWrapper>
                {this.props.children}
                {toolTip && (
                    <div className="tooltip">
                        {toolTip}
                    </div>
                )}
            </MenuBarHighlighterWrapper>
        );
    }
}

const MenuBarButton = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;

    &:hover {

    }
`;

export const MenuBarIconButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    color: #ccc;
    flex-direction: column;
    position: relative;
    cursor: pointer;

    .bai-icon {
        color: white !important;
        font-size: 22px !important;
    }

    &:hover {
        color: ${themeColors.ui_blue};

        .bai-icon {
            color: ${themeColors.ui_blue} !important;
        }

        .hover-label {
            opacity: .75;
        }
    }

    .hover-label {
        color: white;
        font-size: 9px;
        position: absolute;
        bottom: -9px;
        white-space: nowrap;
        opacity: 0;
        transition: opacity 300ms;
    }
`;

const PlayButton = styled.div`
    display: flex;
    align-items: center;

    .bai-icon {
        //color: white;
        font-size: 40px !important;
        margin-right: 10px;

        &:hover {
            color: ${themeColors.ui_blue};
        }
    }

    button {
        padding: 0px;

        label {
            font-size: 11px;
        }

        label {
            font-weight: 600;
            color: #f1f1f1;
            font-size: 12px;
            text-transform: uppercase;
            white-space: nowrap;
            letter-spacing: 0.03em;
        }
    }
`;

const PresentationName = styled.div`
    color: #ddd;
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0px 20px 0px 40px;
    flex-grow: 2;
    text-align: center;
    //max-width: 400px;
    //min-width: 200px;

    label {
        font-size: 16px;
    }

    &:hover {
        color: ${themeColors.ui_blue};
    }
`;

const Template = styled.div`
    background: #ff4500;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 15px;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
`;

const LeftMenuBar = styled.div`
    min-width: 200px;
    display: flex;
    align-items: center;
    height: 100%;
`;

const MiddleMenuBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 2;
    height: 100%;
`;

function PlayButtonComponentBase({ onClick, showSlideGrid }) {
    return (
        <PlayButton id="present-presentation">
            <Icon fill color="white" onClick={onClick}>play_circle</Icon>
            {/*<PopupMenu showArrow showHoverEffect={false} label="Present">*/}
            <MenuPopup showArrow label={t("Present")}>
                <MenuItem
                    onClick={() => AppController.playPresentation({ presentationId: ds.selection.presentation.id, slideIndex: PresentationEditorController.getCurrentSlideIndex() }, { isPreviewFromEditor: true })}
                >
                    {t("Present from Current Slide")}
                </MenuItem>
                <MenuItem
                    onClick={() => AppController.playPresentation({ presentationId: ds.selection.presentation.id, slideIndex: 0 }, { isPreviewFromEditor: true })}
                >
                    {t("Present from Beginning (Cmd-Click)")}
                </MenuItem>
                <MenuItem divider
                    onClick={() => AppController.playPresentation({ presentationId: ds.selection.presentation.id, slideIndex: PresentationEditorController.getCurrentSlideIndex() }, { isPreviewFromEditor: true, openPresenterView: true })}
                >
                    {t("Present with Presenter View")}
                </MenuItem>
                {!showSlideGrid && (
                    <MenuItem
                        onClick={() => PresentationEditorController.playAnimation()}
                    >
                        {t("Preview Animation (Shift-Click)")}
                    </MenuItem>
                )}
            </MenuPopup>
        </PlayButton>
    );
}

const StyledContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;
    padding-left: 20px;
    align-items: center;
    justify-content: center;
`;

class PresentationMenuBarCore extends Component {
    handleShare = () => {
        ShowDialog(ShareDialog, { presentation: ds.selection.presentation, selectedPanel: "collaborate" });
    }

    handlePlay = event => {
        const { presentation, currentSlide, slides } = this.props;

        if (event.shiftKey) {
            PresentationEditorController.playAnimation();
        } else if (event.metaKey) {
            AppController.playPresentation({ presentationId: presentation.id, slideIndex: 0 }, { isPreviewFromEditor: true });
        } else {
            AppController.playPresentation({ presentationId: presentation.id, slideIndex: slides.indexOf(currentSlide) }, { isPreviewFromEditor: true });
        }
    }

    handleExitEditor = () => {
        const { presentation, resources } = this.props;
        const resource = resources.find(resource => resource.resourceId === presentation.id);

        if (resource?.resourceType === WorkspaceResourceType.PRESENTATION_TEMPLATE) {
            if (resource.metadata.isTemplateConfirmed) {
                AppController.showTeamResources({ pane: TeamResourceTypes.PRESENTATION_TEMPLATES });
                return;
            }

            confirmPresentationTemplate(presentation);
            return;
        }

        AppController.showLibrary();
    };

    render() {
        const { currentSlide, slides, presentation, showSlideGrid, isSingleSlideEditor, resources, uiTheme, slideNavWidth } = this.props;

        const resource = resources.find(resource => resource.resourceId === presentation.id);
        const isPresentationTemplate = resource?.resourceType === WorkspaceResourceType.PRESENTATION_TEMPLATE;

        const isTeamTheme = presentation.has("sharedThemeId");
        const canEditTheme = isTeamTheme
            ? WorkspaceController.actionPermissions[ActionPermissionsObject.SHARED_RESOURCES].manage
            : true;

        const ThemeMenuItems = [];
        if (!isTeamTheme && !isSingleSlideEditor) {
            ThemeMenuItems.push(<MenuItem key="edit_theme" onClick={() => PresentationEditorController.showThemeEditor()}><Icon>palette</Icon>{t("Edit Theme...")}</MenuItem>);
        }
        if (isTeamTheme && !isSingleSlideEditor && canEditTheme) {
            ThemeMenuItems.push(<MenuItem key="edit_team_theme" onClick={() => PresentationEditorController.showThemeEditor()}><Icon>link</Icon>{t("Edit Team Theme...")}</MenuItem>);
        }
        ThemeMenuItems.push(<MenuItem key="switch_theme" onClick={() => PresentationEditorController.showSwitchThemeDialog()}><Icon>cycle</Icon>{t("Switch Theme...")}</MenuItem>);

        return (
            <MenuBarContainer id="menubar">

                {!showSlideGrid &&
                    <LeftMenuBar style={{ width: slideNavWidth }}>
                        <NavMenuContainer onClick={this.handleExitEditor}>
                            <MaterialIcon>home</MaterialIcon>
                        </NavMenuContainer>

                        {isPresentationTemplate && <Template>{t("Presentation Template")}</Template>}
                        {!isPresentationTemplate && (
                            <>
                                <Gap10 />
                                <MenuBarHighlighter>
                                    <PresentationMenu presentation={presentation} label={t("Presentation").toUpperCase()} />
                                </MenuBarHighlighter>
                            </>
                        )}
                        <Gap20 />
                        <MenuBarHighlighter>
                            <MenuPopup id="theme-menu" icon="palette" label={t("Theme")} fill color="white" showArrow>
                                {ThemeMenuItems}
                            </MenuPopup>
                        </MenuBarHighlighter>
                        {!isPresentationTemplate && (
                            <MenuBarHighlighter toolTip={t("Analytics")}>
                                <Icon white onClick={() => AppController.showPresentationSettings("analytics", presentation)} style={{ cursor: "pointer", fontSize: 22 }}>finance</Icon>
                            </MenuBarHighlighter>
                        )}
                    </LeftMenuBar>
                }

                <Gap30 />

                <PresentationName id="presentation-name"
                    onClick={() => PresentationEditorController.renamePresentation()}>
                    {presentation.get("name")}
                </PresentationName>
                <MenuBarHighlighter>
                    <PlayButtonComponentBase onClick={this.handlePlay} />
                </MenuBarHighlighter>

                <MenuBarHighlighter>
                    <MenuBarButton id="share-presentation" onClick={this.handleShare}><Icon white>share</Icon>{t("Share")}</MenuBarButton>
                </MenuBarHighlighter>

                <Gap10 />
                <MenuBarHighlighter toolTip={t("Light/Dark")}>
                    <Icon rotate={uiTheme == "dark" ? 0 : 180} white onClick={() => PresentationEditorController.toggleUITheme()} style={{ cursor: "pointer", fontSize: 20 }}>contrast</Icon>
                </MenuBarHighlighter>

                <UserMenuContainer>
                    <Gap15 />
                    <UserMenu showQuickStartGuide showWorkspaceName={false} canSwitchWorkspace showDivider={false} />
                    <Gap15 />
                </UserMenuContainer>
            </MenuBarContainer>
        );
    }
}

const PresentationMenuBar = WorkspaceController.withInitializedState(PresentationMenuBarCore);

const StyledMenuItem = styled(MenuItem)`
    &&& {
        color: ${themeColors.lighterGray};
    }
`;

const PresentationMenu = WorkspaceController.withInitializedState(
    function PresentationMenu({ presentation, resources, label, showArrow }) {
        const resource = resources.find(resource => resource.resourceId === presentation.id);
        const canExportPresentation = WorkspaceController.actionPermissions[ActionPermissionsObject.EXPORT_PRESENTATION].use;
        const canCreatePresentation = WorkspaceController.actionPermissions[ActionPermissionsObject.RESOURCES].create;
        const canUpgradeToCreateResources = WorkspaceController.canUpgradeToRemoveActionRestriction(ActionPermissionsObject.RESOURCES, PermissionActionType.CREATE);
        const currentFilter = PresentationLibraryController.filter;
        const currentFilterMetadata = PresentationLibraryController.filterMetadata;
        const canCreateResources = WorkspaceController.actionPermissions[ActionPermissionsObject.RESOURCES].create;

        if (resource?.resourceType === WorkspaceResourceType.PRESENTATION_TEMPLATE) {
            return null;
        } else {
            return (
                <MenuPopup id="presentation-menu" label={label} showArrow={showArrow} childrenAreMenuItems showHoverEffect={false}>
                    {canCreatePresentation && (
                        <MenuItem onClick={() => AppController.showCreatePresentationDialog({ pane: CreatePresentationDialogPaneType.BLANK_PRESENTATION })}><Icon>new_window</Icon>{t("New Presentation...")}</MenuItem>
                    )}
                    {(currentFilter.type !== PresentationFilters.TEAM_FOLDER || currentFilterMetadata.permissions.write.object) && canCreateResources && (
                        <MenuItem divider onClick={() => PresentationLibraryController.handleDuplicate(presentation.id)}>
                            <Icon>content_copy</Icon>{t("Duplicate")}
                        </MenuItem>
                    )}
                    <MenuItem
                        onClick={() => AppController.showPresentationSettings("share", presentation)}><Icon>share</Icon>{t("Sharing Settings")}</MenuItem>
                    <MenuItem
                        onClick={() => AppController.showPresentationSettings("collaborate", presentation)}><Icon>person_add_alt</Icon>{t("Collaboration")}</MenuItem>
                    <MenuItem divider
                        onClick={() => AppController.showPresentationSettings("player-settings", presentation)}><Icon>play_circle</Icon>{t("Player Settings")}</MenuItem>
                    <MenuItem divider
                        onClick={() => AppController.showPresentationSettings("analytics", presentation)}><Icon>chart_data</Icon>{t("View Analytics")}</MenuItem>
                    <MenuItem divider
                        onClick={() => AppController.showPresentationSettings("version-history", presentation)}><Icon>history</Icon>{t("Recover Deleted Slides")}</MenuItem>
                    {canExportPresentation &&
                        <>
                            <MenuItem
                                onClick={() => AppController.showPresentationSettings("export", presentation)}>
                                <Icon>cloud_download</Icon>{t("Export Presentation")}
                            </MenuItem>
                            <MenuItem divider
                                onClick={() => AppController.showPresentationSettings("export", presentation)}>
                                <Icon>print</Icon>{t("Print Presentation")}
                            </MenuItem>
                        </>
                    }
                    <MenuItem divider onClick={() => PresentationEditorController.renamePresentation()}><Icon>edit_square</Icon>{t("Rename Presentation...")}</MenuItem>
                    <MenuItem
                        onClick={() => AppController.showPresentationSettings("properties", presentation)}>
                        <Icon>info</Icon>{t("View Properties")}
                    </MenuItem>

                    {canUpgradeToCreateResources && (
                        <StyledMenuItem onClick={() => ShowDialog(GuestWorkspaceDialog)}>
                            <img src={getStaticUrl("/images/upgrade-icon.svg")} style={{ marginRight: 6 }} />
                            {t("Duplicate")}
                        </StyledMenuItem>
                    )}

                </MenuPopup>
            );
        }
    });

async function confirmPresentationTemplate(presentation) {
    const existingTags = sortTagsByPopularity(
        WorkspaceController.resources
            .filter(r => r.resourceType === WorkspaceResourceType.PRESENTATION_TEMPLATE)
            .map(r => r.tags));

    const name = presentation.get("name") || "";
    const description = presentation.get("description") || "";
    const tags = presentation.get("tags") || [];

    PresentationEditorController.selectionLayerController.setSelectedElements([]);

    ShowDialog(CreateTeamTemplateDialog, {
        title: t("Publish this template?"),
        subTitle: t("Publish this presentation now and make it available to your team to start from—or save it as a draft and publish it later."),
        name,
        description,
        tags,
        existingTags,
        callback: async ({
            isPublished,
            name,
            description,
            tags,
        }) => {
            await PresentationLibraryController.updatePresentationTemplate(presentation, {
                tags,
                metadata: {
                    isTemplateConfirmed: true,
                    isPublished,
                    name,
                    description,
                }
            });

            AppController.showTeamResources({ pane: TeamResourceTypes.PRESENTATION_TEMPLATES });
        }
    });
}

export default PresentationEditorController.withState(PresentationMenuBar);
